import { useLocalStorage } from '@fortress-technology-solutions/fortress-component-library/hooks';

const useIsDevelopment = () => {
  // Default to false (hidden) even in development environment
  const { localStorageState: isDevMode, setLocalStorage } = useLocalStorage(
    'isDevMode',
    'boolean',
    false,
  );

  return {
    isDevMode,
    toggleIsDevMode: () => setLocalStorage(!isDevMode),
  };
};

export default useIsDevelopment;
